import React from 'react'
import Head from 'next/head'
import type { FAQPage, WithContext, WebSite } from 'schema-dts'

export default function SchemaMarkup({
  schema
}: {
  schema: WithContext<WebSite | FAQPage>
}) {
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schema).replace(/</g, '\\u003c')
        }}
      />
    </Head>
  )
}
